import React from 'react';
import {Trans} from 'react-i18next';
import {Redirect} from 'react-router';
import SingleColumnLayout from '../../components/layout/SingleColumnLayout';
import AsyncListRequest from './listrequest/async';
import AsyncAddOrEditRequest from './addoreditrequest/async';
import AsyncViewRequest from './viewrequest/async';

const parent = {
  title: <Trans i18nKey="c.l.sidebar.12000.title">All Customizations</Trans>,
  path: '/customizations/customization-request',
};

export default [
  <SingleColumnLayout
    exact
    key="a"
    path="/customizations/customization-request"
    component={AsyncListRequest}
    title={
      <Trans i18nKey="c.l.sidebar.12110.title">Customization Request</Trans>
    }
    parents={[parent]}
  />,
  <SingleColumnLayout
    exact
    key="v"
    path="/customizations/customization-request/view/:id"
    component={AsyncViewRequest}
    parents={[parent]}
    title={
      <Trans i18nKey="c.l.sidebar.12110.title">Customization Request</Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="v"
    path="/customizations/customization-request/add"
    component={AsyncAddOrEditRequest}
    parents={[parent]}
    title={
      <Trans i18nKey="c.l.sidebar.12110.title">Customization Request</Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="v"
    path="/customizations/customization-request/edit/:id"
    component={AsyncAddOrEditRequest}
    parents={[parent]}
    title={
      <Trans i18nKey="c.l.sidebar.12110.title">Customization Request</Trans>
    }
  />,
  <Redirect
    key="e"
    exactF
    from="/customizations"
    to="/customizations/customization-request"
  />,
];
